"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.context = void 0;

var symbols_1 = require("../check/symbols");

var constant_1 = require("./constant");

var ContextImplem = /*#__PURE__*/function (_symbols_1$cloneMetho) {
  function ContextImplem() {
    _classCallCheck(this, ContextImplem);

    this.receivedLogs = [];
  }

  _createClass(ContextImplem, [{
    key: "log",
    value: function log(data) {
      this.receivedLogs.push(data);
    }
  }, {
    key: "size",
    value: function size() {
      return this.receivedLogs.length;
    }
  }, {
    key: "toString",
    value: function toString() {
      return JSON.stringify({
        logs: this.receivedLogs
      });
    }
  }, {
    key: _symbols_1$cloneMetho,
    value: function value() {
      return new ContextImplem();
    }
  }]);

  return ContextImplem;
}(symbols_1.cloneMethod);

function context() {
  return (0, constant_1.constant)(new ContextImplem());
}

exports.context = context;